import FormInput from '../../../../../../components/Form/FormInput';
import moment from 'moment';
import { usePersonalAfectado } from '../../../../../../hooks/usePersonalAfectado';
import { useDocumentoPersAfectado } from '../../../../../../hooks/useDocumentoPersAfectado';
import Table, {
  ColumnDefinitionType,
} from '../../../../../../components/Table';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import MyModal from '../../../../../../components/Modal';
import { DocumentoPersPropio } from '../../../../../../types/DocumentoPersPropio';
import { useDocumento } from '../../../../../../hooks/useDocumento';
import { Historial } from '../../../DocumentosAdjuntos/historial';
import {
  downloadAndOpenFile,
  downloadFile,
  findPersonalByTipoAndNumDoc,
  puedeAdjuntar,
} from '../../../../../../services/Service';
import { Button } from 'react-bootstrap';
import FormSelectBox from '../../../../../../components/Form/FormSelectBox';
import { useSolicitud } from '../../../../../../hooks/useSolicitud';
import { AgregarDocumento } from '../../DocumentoAdjunto/agregar';
import { toast } from 'react-toastify';
import {
  APROBADA_STATUS_ID,
  EN_ACTUALIZACION_STATUS_ID,
  EN_PROCESO_STATUS_ID,
  OBSERVADA_STATUS_ID,
  SIN_VISAR_DOCUMENTO_STATUS,
  PRE_APROBADA_STATUS_ID,
} from '../../../../../../constants/constants';
import ObservacionComponent from '../../../../../../components/Observaciones';
import { useUserLogin } from '../../../../../../hooks/useUserLogin';
import Confirm from '../../../../../../components/Confirm';
import { useTipoUsuario } from '../../../../../../hooks/useTipoUsuario';
import { useSolicitudPermissions } from '../../../../../../hooks/useSolicitudPermissions';
import { useTipoDocumento } from '../../../../../../hooks/useTipoDocumento';
import { logger } from '../../../../../../utils/logger';

interface EditPersonalPropioProps {
  tiposDocumentosPers: any;
  onClose: () => void;
  onSave: (
    formData: FormData,
    currentSave: HTMLButtonElement | null
  ) => void;
  isEditing: boolean;
  actividades: any[];
}

interface FormData {
  id: number;
  tipoDocumento: string;
  nroDocumento: string;
  nombre: string;
  apellido: string;
  fechaIngreso: Date | null; // Puede ser una cadena o null
  actividad: string;
  documentosPersPropio: any[];
  vigente: boolean;
  intervienePlanEmergencia: boolean;
  idRolPlanEmergencia: string;
}

const EditPersonalPropio: React.FC<EditPersonalPropioProps> = ({
  onClose,
  isEditing,
  tiposDocumentosPers,
  actividades,
  onSave,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAddDocumentPers, setIsOpenAddDocumentPers] =
    useState(false);
  const [isOpenAddOtherDocuments, setIsOpenAddOtherDocuments] =
    useState(false);
  const [
    isOpenModalConfirmDocumentDelete,
    setIsOpenModalConfirmDocumentDelete,
  ] = useState(false);
  const [actividadSelect, setActividadSelect] = useState<string>('');
  const [
    isOpenModalActividadDocumentDelete,
    setIsOpenModalActividadDocumentDelete,
  ] = useState(false);
  const { solicitudSelected } = useSolicitud();
  const [selectedIdTipoDocumento, setSelectedIdTipoDocumento] =
    useState<number>(0); // Estado para mantener el ID seleccionado
  const toggle = () => setIsOpen(!isOpen);
  const {
    personalPropioSelected,
    buscarPersonalPropioByIdSolicitud,
  } = usePersonalAfectado();
  const [documentoActividad, setDocumentoActividad] = useState<any[]>(
    []
  );
  const [rolesPlanEmergencia, setRolesPlanEmergencia] = useState<
    any[]
  >([]);
  const {
    documentoPersonalPropioList,
    handleDocumentoPersPropioSelected,
    documentoPersonalPropioSelected,
    actualizarDocumentos,
  } = useDocumentoPersAfectado();
  const {
    historialDocumentos,
    handleDocumentoSelected,
    documentoInitial,
  } = useDocumento();
  const { esAnalistaSeguridad } = useTipoUsuario();
  const [
    listDocumentoPersonalPropio,
    setListDocumentoPersonalPropio,
  ] = useState<DocumentoPersPropio[]>([]);
  const [minDateFechaIngreso, setMinDateFechaIngreso] =
    useState<Date>();
  const [formData, setFormData] = useState<FormData>({
    id: 0,
    tipoDocumento: '',
    nroDocumento: '',
    nombre: '',
    apellido: '',
    fechaIngreso: null,
    actividad: '',
    documentosPersPropio: [],
    vigente: true,
    intervienePlanEmergencia: false,
    idRolPlanEmergencia: '',
  });
  const [showModalSalir, setShowModalSalir] =
    useState<boolean>(false);

  const [
    isOpenModalObservacionDocument,
    setIsOpenModalObservacionDocument,
  ] = useState(false);
  const [isOpenModalHistorial, setIsOpenModaHistorial] =
    useState(false);
  // Usar el hook unificado de permisos
  const {
    isFormDisabled,
    isFormFieldDisabledInEditMode,
    canShowObservations,
    canShowHistory,
    isDocumentStatusCheckEnabled,
    shouldShowObservationColumn,
    isContratista,
  } = useSolicitudPermissions({
    solicitudEstadoId: solicitudSelected.idTipoEstado,
  });

  const [isDisabled] = useState<boolean>(isFormDisabled);
  const [saveRevision, setSaveRevision] = useState(false);
  const [estados] = useState<any>([
    {
      id: true,
      valor: 'Activo',
    },
    {
      id: false,
      valor: 'Inactivo',
    },
  ]);
  let btnRef = useRef<HTMLButtonElement>(null);

  const { cargarCombo } = useSolicitud();
  const { buscarTiposDocumentos, tipoDocumentoList } =
    useTipoDocumento();
  const [tiposDocumentosDirectos, setTiposDocumentosDirectos] =
    useState<any[]>([]);

  const handleDocumento = async (id: number) => {
    setSelectedIdTipoDocumento(id);
    setIsOpenModaHistorial(true);
  };
  const getDocumentoSelected = (id: number) => {
    if (id) {
      const doc =
        historialDocumentos.find((d) => d.idTipoDocumento === id) ||
        documentoInitial;
      handleDocumentoSelected(doc);
      toggle();
      setSelectedIdTipoDocumento(0);
    }
  };

  useEffect(() => {
    if (solicitudSelected.fechaInicio) {
      let dateInicioValue = moment(
        solicitudSelected.fechaInicio
      ).toDate();
      setMinDateFechaIngreso(dateInicioValue);
    }

    // Cargar roles de plan de emergencia
    cargarCombo('roles-plan-emergencia', setRolesPlanEmergencia);

    // Cargar tipos de documentos directos desde TipoDocumento table
    buscarTiposDocumentos({
      id: 0,
      nombre: '',
      activo: true,
      descripcion: '',
      sizeMaximo: 0,
      formatoArchivo: '',
      contenidoPlantilla: null,
      nombrePlantilla: null,
      formatos: [],
    });

    if (isEditing && personalPropioSelected.id !== 0) {
      // Si estás en modo edición, puedes cargar los datos existentes en el estado formData
      // Utiliza los datos cargados para inicializar formData
      // Ejemplo:
      setFormData({
        id: personalPropioSelected.id,
        tipoDocumento: personalPropioSelected.idTipoDocumento,
        nombre: personalPropioSelected.nombre,
        actividad: personalPropioSelected.idActividad,
        apellido: personalPropioSelected.apellido,
        fechaIngreso:
          personalPropioSelected.fechaIngreso !== ''
            ? moment(
                personalPropioSelected.fechaIngreso,
                'YYYY-MM-DD'
              ).toDate()
            : null,
        nroDocumento: personalPropioSelected.nroDocumento,
        documentosPersPropio: documentoPersonalPropioList,
        vigente: personalPropioSelected.vigente,
        intervienePlanEmergencia:
          personalPropioSelected.intervienePlanEmergencia || false,
        idRolPlanEmergencia:
          personalPropioSelected.idRolPlanEmergencia
            ? personalPropioSelected.idRolPlanEmergencia.toString()
            : '',
      });
      cargarCombo(
        `documentoActividad/actividad/${personalPropioSelected.idActividad}`,
        setDocumentoActividad
      );
    }
  }, []);

  useEffect(() => {
    if (documentoPersonalPropioList.length > 0) {
      setListDocumentoPersonalPropio(
        documentoPersonalPropioList.map((documento) => ({
          id: documento.id,
          idTipoDocumento: documento.idTipoDocumento,
          tipoDocumento: documento.tipoDocumento,
          nombreArchivo: documento.nombreArchivo,
          fileId: documento.fileId,
          subido: documento.subido,
          ubicacion: documento.ubicacion,
          fechaVencimiento: documento.fechaVencimiento,
          formatoArchivo: documento.formatoArchivo,
          nombreTipoDocumento: documento.nombreTipoDocumento,
          idSolicitud: solicitudSelected.id,
          archivoSeleccionado: null,
          statusDocumento: documento.statusDocumento,
          observacion: documento.observacion,
          sizeMaximo: documento.sizeMaximo,
        }))
      );
    }
  }, [documentoPersonalPropioList]);

  useEffect(() => {
    // Dependiendo de cómo se use historialDocumentos, podrías necesitar un efecto para manejar su actualización
    // Realiza las acciones que necesites con el historialDocumentos actualizado aquí
    getDocumentoSelected(selectedIdTipoDocumento);
  }, [historialDocumentos]);

  useEffect(() => {
    // Mapear tipos de documento para uso en "Agregar Otros Documentos"
    if (tipoDocumentoList.length > 0) {
      const tiposDocumentosFormateados = tipoDocumentoList.map(
        (tipo) => ({
          id: tipo.id,
          tipoDocumentoId: tipo.id,
          tipoDocumentoNombre: tipo.nombre,
          sizeMaximo: tipo.sizeMaximo || 20,
          formatos:
            tipo.formatos?.map((formato) => formato?.nombre) || [], // ← Cambio: extension → nombre
        })
      );

      setTiposDocumentosDirectos(tiposDocumentosFormateados);
    }
  }, [tipoDocumentoList]);

  const columns: ColumnDefinitionType<
    DocumentoPersPropio,
    keyof DocumentoPersPropio
  >[] = [];

  columns.push({
    key: 'tipoDocumento',
    header: 'TIpo Documento',
  });
  columns.push({
    key: 'nombreArchivo',
    header: 'Nombre',
  });
  columns.push({
    key: 'fechaVencimiento',
    header: 'Fecha Vencimiento',
    cell: (data: DocumentoPersPropio) => (
      <>
        {data.fechaVencimiento
          ? moment(data.fechaVencimiento).format('DD/MM/YYYY')
          : ''}
      </>
    ),
  });
  if (shouldShowObservationColumn) {
    columns.push({
      key: 'observacion',
      header: 'Observaciones',
      cell: (data: DocumentoPersPropio) => (
        <>
          {data.observacion && (
            <a
              href="#"
              title="Observaciones"
              onClick={() => {
                handleDocumentoPersPropioSelected(data);
                setIsOpenModalObservacionDocument(true);
              }}
            >
              <i
                className="fa fa-search me-2"
                style={{ color: 'red' }}
                aria-hidden="true"
              ></i>
            </a>
          )}
        </>
      ),
    });
  }
  columns.push({
    key: 'id',
    header: 'Acciones',
    cell: (data: DocumentoPersPropio) => (
      <>
        <Link
          title="Visualizar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadAndOpenFile(
              'documento-personal/visualizarArchivo',
              data
            );
          }}
          target="_blank"
        >
          <i
            className="fa fa-eye text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        <Link
          title="Descargar"
          to="/exportar"
          onClick={(e) => {
            e.preventDefault();
            downloadFile('documento-personal/descargarArchivo', data);
          }}
          target="_blank"
        >
          <i
            className="fa fa-arrow-down text-secondary me-2"
            aria-hidden="true"
          ></i>
        </Link>
        {!isDisabled &&
          solicitudSelected.idTipoEstado !== OBSERVADA_STATUS_ID &&
          solicitudSelected.idTipoEstado !== APROBADA_STATUS_ID && (
            <Link
              title="Eliminar"
              to="/delete"
              onClick={(e) => {
                e.preventDefault();
                setIsOpenModalConfirmDocumentDelete(true);
                setSelectedIdTipoDocumento(data.idTipoDocumento);
              }}
              target="_blank"
            >
              <i
                className="fa fa-trash text-secondary me-2"
                aria-hidden="true"
              ></i>
            </Link>
          )}
        {canShowObservations && (
          <a
            href="#"
            title="Observaciones"
            onClick={() => {
              handleDocumentoPersPropioSelected(data);
              setIsOpenModalObservacionDocument(true);
            }}
          >
            <i
              className="fa fa-search text-secondary me-2"
              aria-hidden="true"
            ></i>
          </a>
        )}
        {canShowHistory && (
          <a
            href="#"
            title="Historial de Documentos"
            onClick={() => handleDocumento(data.idTipoDocumento)}
          >
            <i
              className="fa fa-history text-secondary "
              aria-hidden="true"
            ></i>
          </a>
        )}
      </>
    ),
  });
  columns.push({
    key: 'statusDocumento',
    header: '',
    isEnabledCheckStatusDocument: isDocumentStatusCheckEnabled,
  });

  const handleInputChange = (name: string, value: any) => {
    // Actualiza el estado con el nuevo valor
    if (name === 'actividad') {
      if (listDocumentoPersonalPropio.length > 0) {
        setIsOpenModalActividadDocumentDelete(true);
        setActividadSelect(value);
        return;
      }
      cargarCombo(
        `documentoActividad/actividad/${value}`,
        setDocumentoActividad
      );
    }

    // 🔥 FIX: Si se deselecciona "Interviene Plan Emergencia", resetear el Rol
    if (name === 'intervienePlanEmergencia' && !value) {
      setFormData({
        ...formData,
        [name]: value,
        idRolPlanEmergencia: '', // ← Resetear a "Seleccionar"
      });
      return; // ← AGREGAR RETURN para evitar que se ejecute el setFormData de abajo
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleOpenAddDocumentPerson = () => {
    if (formData.actividad) {
      cargarCombo(
        `documentoActividad/actividad/${formData.actividad}`,
        setDocumentoActividad
      );
      setIsOpenAddDocumentPers(true);
    } else {
      toast.error('Por favor, seleccionar una Actividad.');
    }
  };

  const handleOpenAddOtherDocuments = () => {
    setIsOpenAddOtherDocuments(true);
  };

  const validationPreSavedPersonalPropio = () => {
    if (canShowObservations) {
      btnRef!.current!.disabled = true;
      saveRevisionButtonFn();
      onClose();
    } else {
      if (!formData.tipoDocumento) {
        toast.error('Por favor, seleccionar un Tipo de Documento.');
        return;
      }

      if (!formData.nroDocumento) {
        toast.error('Por favor, completar el número Documento.');
        return;
      }

      if (!formData.nombre) {
        toast.error('Por favor, completar el nombre.');
        return;
      }

      if (!formData.apellido) {
        toast.error('Por favor, completar el apellido.');
        return;
      }

      if (!formData.fechaIngreso) {
        toast.error('Por favor, completar la fecha de Ingreso.');
        return;
      }

      if (!formData.actividad || formData.actividad === '0') {
        toast.error('Por favor, seleccionar una Actividad.');
        return;
      }

      if (
        formData.intervienePlanEmergencia &&
        (!formData.idRolPlanEmergencia ||
          formData.idRolPlanEmergencia === '0')
      ) {
        toast.error(
          'Por favor, seleccionar un Rol para el Plan de Emergencia.'
        );
        btnRef!.current!.disabled = false;
        return;
      }
      btnRef!.current!.disabled = true;
      formData.documentosPersPropio = listDocumentoPersonalPropio;
      if (
        solicitudSelected.idTipoEstado === APROBADA_STATUS_ID ||
        solicitudSelected.idTipoEstado === EN_ACTUALIZACION_STATUS_ID
      ) {
        // findDeletedDocuments(data.documentosPersSubContratado).forEach(documentDelete => deleteDocPersById('documento-personal-subcontratado', documentDelete.id));
        let documentUpload = formData.documentosPersPropio.filter(
          (documentPersPropio: any) =>
            documentPersPropio.archivoSeleccionado
        );
        if (documentUpload?.length >= 1) {
          (async () => {
            try {
              let documentos = documentUpload.map(
                (documentPersPropio: any) => {
                  return {
                    ...documentPersPropio,
                    archivoSeleccionado: null,
                  };
                }
              );
              let puedeAdj: boolean = await puedeAdjuntar(
                `documento-personal`,
                documentos
              );

              if (!puedeAdj) {
                toast.error(
                  'Se pueden adjuntar Tipos de Documentos vencidos, próximos a vencerse o no obligatorios'
                );
                btnRef!.current!.disabled = false;
                return;
              } else {
                onSave(formData, btnRef!.current);
                onClose();
              }
            } catch (error) {
              logger.error(
                'Error al verificar la fecha de vencimiento del documento:',
                logger.safeError(error)
              );
            }
          })();
        } else {
          onSave(formData, btnRef!.current);
        }
      } else {
        onSave(formData, btnRef!.current);
      }
    }
    // btnRef!.current!.disabled = false;
  };

  const addDocumentConfirmSave = (data: any) => {
    const documentoExistente = listDocumentoPersonalPropio.find(
      (doc) => doc.idTipoDocumento === data.idTipoDocumento
    );

    if (documentoExistente) {
      // Si el documento ya existe, reemplaza el existente con el nuevo documento.
      let replaceDocument = { ...documentoExistente };
      replaceDocument.archivoSeleccionado = data.archivoSeleccionado;
      replaceDocument.idSolicitud = solicitudSelected.id;
      replaceDocument.tipoDocumento = data.tipoDocumento;
      replaceDocument.nombreArchivo = data.archivoSeleccionado.name;
      replaceDocument.statusDocumento = '';
      replaceDocument.observacion = '';
      replaceDocument.sizeMaximo = data.sizeMaximo;
      replaceDocument.fechaVencimiento = data.fechaVencimiento || '';
      replaceDocumentoPersPropioByIdTipoDocumento(replaceDocument);
      setIsOpenAddDocumentPers(true);
    } else {
      // Si el documento no existe, simplemente agrégalo al array.
      //let newDocumento = documentoPersPropioInitial;
      let documentoPersPropioInitial: DocumentoPersPropio = {
        id: 0,
        idTipoDocumento: data.idTipoDocumento,
        tipoDocumento: data.tipoDocumento,
        nombreArchivo: data.archivoSeleccionado.name,
        fileId: 0,
        subido: false,
        ubicacion: '',
        fechaVencimiento: data.fechaVencimiento || '',
        formatoArchivo: '',
        nombreTipoDocumento: '',
        idSolicitud: solicitudSelected.id,
        archivoSeleccionado: data.archivoSeleccionado,
        statusDocumento: '',
        observacion: '',
        sizeMaximo: data.sizeMaximo,
      };

      setListDocumentoPersonalPropio((prevList) => [
        ...prevList,
        documentoPersPropioInitial,
      ]);
    }
  };

  const replaceDocumentoPersPropioByIdTipoDocumento = (
    nuevoElemento: DocumentoPersPropio
  ) => {
    setListDocumentoPersonalPropio((prevList) => {
      return prevList.map((item) => {
        if (item.idTipoDocumento === nuevoElemento.idTipoDocumento) {
          return nuevoElemento; // Reemplazar el elemento si se encuentra
        }
        return item; // Mantener el elemento sin cambios si no coincide el ID
      });
    });
  };

  const deleteDocumentoPersPropioByIdTipoDocumento = (
    idTipoDocumentoAEliminar: number
  ) => {
    setListDocumentoPersonalPropio((prevList) => {
      return prevList.filter(
        (item) => item.idTipoDocumento !== idTipoDocumentoAEliminar
      );
    });
  };

  const handleConfirmDeleteDocument = () => {
    deleteDocumentoPersPropioByIdTipoDocumento(
      selectedIdTipoDocumento
    );
    setIsOpenModalConfirmDocumentDelete(false);
  };

  const handleConfirmActividadDeleteAllDocument = () => {
    setListDocumentoPersonalPropio([]);
    setFormData({
      ...formData,
      actividad: actividadSelect,
    });
    cargarCombo(
      `documentoActividad/actividad/${actividadSelect}`,
      setDocumentoActividad
    );
    setIsOpenModalActividadDocumentDelete(false);
  };

  const onCheckboxChange = (
    data: DocumentoPersPropio,
    status: string
  ) => {
    setSaveRevision(true);
    setListDocumentoPersonalPropio((prevList: any) => {
      return prevList.map((item: any) => {
        if (data.id === item.id) {
          // Modificamos solo el elemento deseado
          return { ...item, statusDocumento: status };
        }
        // Mantenemos los demás elementos sin cambios
        return item;
      });
    });
  };

  const handleInputChangeNumDoc = (name: string, value: any) => {
    let tipoDoc: string = '';
    let numDocumento: string = '';

    if (name === 'nroDocumento') {
      numDocumento = value;
      tipoDoc = formData.tipoDocumento;
    } else if (name === 'tipoDocumento') {
      numDocumento = formData.nroDocumento;
      tipoDoc = value;
    }

    if (tipoDoc !== '' && numDocumento !== '') {
      findPersonalByTipoAndNumDoc(
        parseInt(tipoDoc),
        numDocumento
      ).then((respuesta) => {
        if (respuesta) {
          setFormData({
            ...formData,
            [name]: value,
            nombre: respuesta.data.nombre,
            apellido: respuesta.data.apellido,
          });
        } else {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    // logger.log('formData listo para enviar');
  };

  const onObservacionChange = (observacion: string) => {
    setIsOpenModalObservacionDocument(false);
    setListDocumentoPersonalPropio((prevList: any) => {
      return prevList.map((item: any) => {
        if (documentoPersonalPropioSelected.id === item.id) {
          // Modificamos solo el elemento deseado
          return { ...item, observacion: observacion };
        }
        // Mantenemos los demás elementos sin cambios
        return item;
      });
    });
  };

  const saveRevisionButtonFn = () => {
    const documentoUpdateStatus = [];
    // let sinRevisar: boolean = false;
    for (const documento of listDocumentoPersonalPropio) {
      // if (!documento.statusDocumento || documento.statusDocumento.trim() === SIN_VISAR_DOCUMENTO_STATUS) {
      //     // Si encuentra un documento sin statusDocumento, detener el bucle
      //     sinRevisar = true;
      //     break;
      // }
      documentoUpdateStatus.push({
        id: documento.id,
        statusDocumento: documento.statusDocumento,
        observacion: documento.observacion,
      });
    }
    // if (sinRevisar) {
    //     toast.error("Debe chequear los documentos sin revisar");
    //     btnRef!.current!.disabled = false;
    // } else {
    actualizarDocumentos(documentoUpdateStatus, 'documento-personal')
      .then((respuesta) => {
        buscarPersonalPropioByIdSolicitud(solicitudSelected.id);
        toast.success('Se actualizaron los documentos revisados');
      })
      .catch((error) => {
        toast.error('Error al actualizar los documentos revisados');
      });

    // }
  };
  const toggleSalir = () => {
    setShowModalSalir(!showModalSalir);
  };
  const onCloseSalir = () => {
    setShowModalSalir(!showModalSalir);
    onClose();
  };

  return (
    <>
      <MyModal
        isOpen={isOpenModalObservacionDocument}
        toggle={() => setIsOpenModalObservacionDocument(false)}
        title="Observaciones"
        cancelButton={false}
        secondButton={false}
      >
        <ObservacionComponent
          observacion={documentoPersonalPropioSelected.observacion}
          saveButtonFn={onObservacionChange}
          isEdit={!isContratista}
          cancelButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
          returnButtonFn={() =>
            setIsOpenModalObservacionDocument(false)
          }
        ></ObservacionComponent>
      </MyModal>
      <MyModal
        isOpen={isOpenModalActividadDocumentDelete}
        toggle={() => setIsOpenModalActividadDocumentDelete(false)}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        titleCancelar={'Cancelar'}
        secondButtonFn={handleConfirmActividadDeleteAllDocument}
      >
        <label>
          Si cambia la Actividad se van a eliminar los documentos
          adjuntados. Desea confirmar?
        </label>
      </MyModal>
      <MyModal
        isOpen={isOpenModalConfirmDocumentDelete}
        toggle={() => setIsOpenModalConfirmDocumentDelete(false)}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        titleCancelar={'Cancelar'}
        secondButtonFn={handleConfirmDeleteDocument}
      >
        <label>Confirma la eliminación del registro?</label>
      </MyModal>
      <MyModal
        isOpen={isOpenModalHistorial}
        toggle={() => setIsOpenModaHistorial(false)}
        title="Historial de Documentos"
      >
        <Historial
          tipoDocumentoDisabled={true}
          pathService={`documento-personal/personal-propio/${personalPropioSelected.id}`}
          idTipoDocumentoSelected={selectedIdTipoDocumento}
        />
      </MyModal>
      <MyModal
        isOpen={isOpenAddDocumentPers}
        toggle={() => setIsOpenAddDocumentPers(false)}
        title="Agregar Documentos"
        enabledFooter={false}
      >
        <AgregarDocumento
          tipoDocumentoDisabled={true}
          cancelButtonFn={() => setIsOpenAddDocumentPers(false)}
          listDocumentos={listDocumentoPersonalPropio}
          saveCompletedButtonFn={(addDocument) => {
            addDocumentConfirmSave(addDocument);
          }}
          documentoActividad={documentoActividad}
        />
      </MyModal>
      <MyModal
        isOpen={isOpenAddOtherDocuments}
        toggle={() => setIsOpenAddOtherDocuments(false)}
        title="Agregar Otros Documentos"
        enabledFooter={false}
      >
        <AgregarDocumento
          tipoDocumentoDisabled={false}
          cancelButtonFn={() => setIsOpenAddOtherDocuments(false)}
          listDocumentos={listDocumentoPersonalPropio}
          saveCompletedButtonFn={(addDocument) => {
            addDocumentConfirmSave(addDocument);
          }}
          documentoActividad={tiposDocumentosDirectos}
          isOtrosDocumentos={true}
        />
      </MyModal>
      <MyModal
        isOpen={showModalSalir}
        toggle={toggleSalir}
        title="Advertencia"
        cancelButton={true}
        secondButton={true}
        secondButtonTitle={'Aceptar'}
        secondButtonFn={onCloseSalir}
      >
        <label>Desea Salir sin guardar los cambios?</label>
      </MyModal>
      <div>
        <div className="row mt-2">
          <FormSelectBox
            id={'tipoDocumento'}
            label={'Tipo Doc Persona'}
            name={'tipoDocumento'}
            value={formData.tipoDocumento || ''}
            isDisabled={isFormFieldDisabledInEditMode(formData.id)}
            title={'Tipo Doc Persona'}
            onChange={(e) =>
              handleInputChangeNumDoc(e.target.name, e.target.value)
            }
            optionId={'id'}
            optionLabel={'tipoDocumento'}
            options={tiposDocumentosPers}
            classLabel="col-form-label col-2 text-end"
            classDivSelect="col-4"
          />
          <FormInput
            id={'nroDocumento'}
            label={'Nro. Documento'}
            name={'nroDocumento'}
            value={formData.nroDocumento || ''}
            onChange={(e) =>
              handleInputChangeNumDoc(e.target.name, e.target.value)
            }
            isDisabled={isFormFieldDisabledInEditMode(formData.id)}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'nombre'}
            label={'Nombre'}
            name={'nombre'}
            value={formData.nombre || ''}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            isDisabled={isFormFieldDisabledInEditMode(formData.id)}
          />
          <FormInput
            id={'apellido'}
            label={'Apellido'}
            name={'apellido'}
            value={formData.apellido || ''}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            isDisabled={isFormFieldDisabledInEditMode(formData.id)}
          />
        </div>
        <div className="row mt-2">
          <FormInput
            id={'fechaIngreso'}
            label={'Fecha Ingreso Trabajo'}
            type="date"
            name={'fechaIngreso'}
            value={formData.fechaIngreso}
            onDateChange={(date: Date | null, name: string) => {
              handleInputChange(name, date);
            }}
            minDate={minDateFechaIngreso}
            isDisabled={isFormFieldDisabledInEditMode(formData.id)}
          />
        </div>
        <div className="row mt-2">
          <FormSelectBox
            id={'actividad'}
            label={'Actividad'}
            name={'actividad'}
            value={formData.actividad || ''}
            isDisabled={isFormFieldDisabledInEditMode(formData.id)}
            title={'Actividad'}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            optionId={'id'}
            optionLabel={'nombreActividad'}
            options={actividades}
            classLabel="col-form-label col-2 text-end"
            classDivSelect="col-4"
          />
        </div>
        <div className="row mt-2">
          <div
            className="form-check mt-2 col-4"
            style={{ marginLeft: '10rem' }}
          >
            <input
              className="form-check-input"
              type="checkbox"
              id="intervienePlanEmergencia"
              name="intervienePlanEmergencia"
              checked={formData.intervienePlanEmergencia}
              disabled={isFormFieldDisabledInEditMode(formData.id)}
              onChange={(e) =>
                handleInputChange(e.target.name, e.target.checked)
              }
              style={{
                width: '15px',
                height: '15px',
                accentColor: '#161718ff',
                transform: 'scale(1.3)',
                marginRight: '10px',
              }}
            />
            <label
              className="form-check-label"
              htmlFor="intervienePlanEmergencia"
              style={{
                fontWeight: '800',
                color: 'grey',
                fontSize: '14px',
                cursor: isFormFieldDisabledInEditMode(formData.id)
                  ? 'default'
                  : 'pointer',
              }}
            >
              Interviene en Plan Emergencia
            </label>
          </div>

          <FormSelectBox
            id={'idRolPlanEmergencia'}
            label={'Rol'}
            name={'idRolPlanEmergencia'}
            value={formData.idRolPlanEmergencia || ''}
            isDisabled={
              isFormFieldDisabledInEditMode(formData.id) ||
              !formData.intervienePlanEmergencia
            }
            title={'Rol'}
            onChange={(e) =>
              handleInputChange(e.target.name, e.target.value)
            }
            optionId={'id'}
            optionLabel={'rol'}
            options={rolesPlanEmergencia}
            classLabel="col-form-label col-2 text-end"
            classDivSelect="col-4"
          />
        </div>
        {(solicitudSelected.idTipoEstado === APROBADA_STATUS_ID ||
          solicitudSelected.idTipoEstado ===
            EN_ACTUALIZACION_STATUS_ID) && (
          <div className="row mt-2">
            <FormSelectBox
              id={'vigente'}
              label={'Estado'}
              name={'vigente'}
              value={formData.vigente || ''}
              // isDisabled={formData.id !== 0}
              title={'Estado'}
              onChange={(e) =>
                handleInputChange(e.target.name, e.target.value)
              }
              optionId={'id'}
              optionLabel={'valor'}
              options={estados}
              classLabel="col-form-label col-2 text-end"
              classDivSelect="col-4"
            />
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="row">
          <div className="col-md-12 text-end">
            {!isDisabled && (
              <>
                <Button
                  disabled={
                    isDisabled ||
                    !formData.vigente ||
                    documentoActividad.length === 0
                  }
                  className="btn-secondary me-2"
                  variant="secondary"
                  onClick={() => handleOpenAddDocumentPerson()}
                >
                  Agregar Documentos Actividad
                </Button>
                <Button
                  disabled={
                    isDisabled ||
                    !formData.vigente ||
                    !formData.intervienePlanEmergencia
                  }
                  className="btn-secondary"
                  variant="secondary"
                  onClick={() => handleOpenAddOtherDocuments()}
                >
                  Agregar Otros Documentos
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="table-responsive ">
          <Table
            data={listDocumentoPersonalPropio}
            columns={columns}
            onCheckboxChange={onCheckboxChange}
          ></Table>
        </div>
      </div>
      <div className="col-md-12 d-flex justify-content-center">
        <Button
          color="secondary"
          onClick={validationPreSavedPersonalPropio}
          className="mr-2"
          ref={btnRef}
        >
          Guardar
        </Button>
        <Button
          color="secondary"
          onClick={toggleSalir}
          className="mr-2"
        >
          Salir
        </Button>
      </div>
    </>
  );
};

export default EditPersonalPropio;
